import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';

import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from './../components/components.module'

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';

import { LicenseKeyService } from './../providers/license-key.service';
import { AuthService } from './../providers/auth.service';
import { NavService } from './../providers/nav.service';
import { EnvService } from '../providers/env.service';
import { CsvService } from '../providers/csv.service';

import { ApiAuthService } from './../providers/api-call-providers/api-auth.service';
import { ApiAuthLicenseKeyService } from './../providers/api-call-providers/api-auth-license-key.service';
import { ApiUserPasswordService } from './../providers/api-call-providers/api-user-password.service';
import { ApiLoginService } from './../providers/api-call-providers/api-login.service';
import { ApiLogoutService } from './../providers/api-call-providers/api-logout.service';
import { ApiPatientService } from './../providers/api-call-providers/api-patient.service';
import { ApiStaffService } from './../providers/api-call-providers/api-staff.service';

import { ApiDashboardService } from './../providers/api-call-providers/api-dashboard.service';
import { ApiPatientVitalgrafService } from './../providers/api-call-providers/api-patient-vitalgraf.service';
import { ApiNewsService } from './../providers/api-call-providers/api-news.service';
import { ApiContractService } from './../providers/api-call-providers/api-contract.service';
import { ApiMasterService } from './../providers/api-call-providers/api-master.service';
import { ApiActionLogsService } from './../providers/api-call-providers/api-action-logs.service';
import { ApiSleepService } from './../providers/api-call-providers/api-sleep.service';

import { StateService } from './../providers/state.service';
import { AlertService } from './../providers/alert.service';
import { ToastService } from './../providers/toast.service';
import { MaintenanceService } from './../providers/maintenance.service';
import { VersionupService } from './../providers/versionup.service';
import { UserService } from './../providers/user.service';
import { PatientService } from './../providers/patient.service';
import { StaffService } from './../providers/staff.service';
import { ContractService } from './../providers/contract.service';
import { DateService } from './../providers/date.service';
import { DataCacheService } from './../providers/data-cache.service';
import { NewsService } from '../providers/news.service';
import { ActionLogsService } from '../providers/action-logs.service';
import { SleepService } from '../providers/sleep.service';

import { DebuglogService } from './../providers/debuglog.service';

import { ApiAuthStore } from './../providers/store/api.auth.store';
import { SideMenuService } from './../providers/side.menu.service';
import { DashboardService } from './../providers/dashboard.service';
import { MasterService } from './../providers/master.service';

import { LoadingComponent } from './../components/loading/loading';
import { SleepSensorService } from '../providers/sleep-sensor.service';
import { ApiSleepSensorService } from './../providers/api-call-providers/api-sleep-sensor.service';
import { SettingSyncCareSystemService } from '../providers/setting-sync-care-system.service';
import { ApiSettingSyncCareSystemService } from '../providers/api-call-providers/api-setting-sync-care-system.service';
import { SensorLogsService } from '../providers/sensor-logs.service'
import { ApiSensorLogsService } from '../providers/api-call-providers/api-sensor-logs.service';
import { NurseCallService } from '../providers/nurse-call.service';
import { ApiNurseCallService } from '../providers/api-call-providers/api-nurse-call.service';
import { RoomService } from '../providers/room.service';
import { ApiRoomService } from '../providers/api-call-providers/api-room.service';
import { UtilService } from '../providers/util.service';


import { ApiCurrentCareRecordsServce } from '../providers/api-call-providers/api-current-care-records.service';
import { ApiDebugService } from '../providers/api-call-providers/api-debug.service';
import { ApiDebugCareSystemService } from '../providers/api-call-providers/api-debug-caresystem.service';
import { ApiTasksLogsService } from '../providers/api-call-providers/api-tasks-logs.service';
import { CurrentCareRecordsServce } from '../providers/current-care-records.servce';
import { WebSocketService } from '../providers/web-socket.service';

import { CarecomService } from '../providers/nursecall/carecom.service';
import { CocohelpaService } from '../providers/nursecall/cocohelpa.service';

@NgModule({
  declarations: [MyApp, HomePage],
  imports: [
    BrowserModule,
    CommonModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    ComponentsModule,
    IonicModule.forRoot(MyApp, {
      menuType: "overlay",
      backButtonText: "",
    }),
    IonicStorageModule.forRoot({
      name: "cdc_client",
      driverOrder: ["websql", "sqlite", "indexeddb"],
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp, HomePage, LoadingComponent],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    AuthService,
    LicenseKeyService,
    NavService,
    ApiAuthService,
    ApiUserPasswordService,
    ApiAuthLicenseKeyService,
    ApiLoginService,
    ApiLogoutService,
    ApiPatientService,
    ApiStaffService,
    ApiDashboardService,
    ApiPatientVitalgrafService,
    ApiNewsService,
    ApiContractService,
    ApiMasterService,
    ApiActionLogsService,
    UserService,
    StateService,
    AlertService,
    ToastService,
    MaintenanceService,
    VersionupService,
    PatientService,
    StaffService,
    ContractService,
    DateService,
    DataCacheService,
    NewsService,
    ActionLogsService,
    DebuglogService,
    ApiAuthStore,
    SideMenuService,
    DashboardService,
    MasterService,
    SleepSensorService,
    ApiSleepSensorService,
    SettingSyncCareSystemService,
    ApiSettingSyncCareSystemService,
    SensorLogsService,
    ApiSensorLogsService,
    NurseCallService,
    ApiNurseCallService,
    RoomService,
    ApiRoomService,
    ApiSleepService,
    SleepService,
    UtilService,
    ApiCurrentCareRecordsServce,
    ApiTasksLogsService,
    ApiDebugService,
    ApiDebugCareSystemService,
    CurrentCareRecordsServce,
    WebSocketService,
    EnvService,
    CsvService,
    CarecomService,
    CocohelpaService,
  ],
})
export class AppModule {}


// WEBPACK FOOTER //
// ./src/app/app.module.ts